import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { TurmasList } from './TurmasList'
import { TurmaDetail } from './TurmaDetail'

export const Turmas = () => {
  return (
    <Switch>
      <Route exact path="/turmas" component={TurmasList} />
      <Route path="/turmas/:id" component={TurmaDetail} />
    </Switch>
  )
}